import axios from 'axios';
import router from '@/router';
import store from "@/store";
//import useAuthStore from '@/store/auth'; //vuex
import { useAuthStore } from '@/store/authPinia';
import { shopService } from "@/services/shopService";

const API_URL = process.env.VUE_APP_API_URL;
const APIAUTH_URL = process.env.VUE_APP_APIAUTH_URL;
const AppKey = process.env.VUE_APP_APP_KEY;
//axios.defaults.baseURL = API_URL;
//--------------------------------------------
// const eventSource = new EventSource(API_URL + "sse/notifications");

// eventSource.onmessage = (event) => {
//     console.log("SSE Powiadomienie:", event.data);
//     const data = JSON.parse(event.data);
//     alert(data.message);
// };

// eventSource.onopen = () => {
//     console.log('Połączono z SSE');
//     //reconnectDelay = 1000;  // Resetuj opóźnienie po udanym połączeniu
// };

// eventSource.onerror = (error) => {
//     console.error("Błąd SSE:", error);
// };
//--------------------------------------------
//------------------------------------------------------------------------------------------------------

async function loadShops() {
    try {

        const response = await shopService.getShops();

        if (response.data?.Success) {
            console.log(">>>>>>>>>>>>Response Data:", response.data.Data)
            store.commit("SET_SHOPS", response.data.Data);
            store.commit("SET_SELECTED_SHOP", response.data.Data.find(shop => shop.IsSelected) || null);
        }
    } catch (error) {
        console.error(error);
    }
}

//------------------------------------------------------------------------------------------------------
// Ustawienie tokena w nagłówkach
function authHeader() {
    const token = localStorage.getItem('authToken');
    if (token) {
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

class AuthService {
    constructor() {
        this.serviceName = 'AuthService';
    }

    log(message, data) {
        const currentRoute = router.currentRoute.value;

        console.log(
            `[${this.serviceName}]`,
            `[${currentRoute.name}]`,
            message,
            data ?? ''
        );

        // console.log({
        //     service: this.serviceName,
        //     route: currentRoute.name,
        //     path: currentRoute.path,
        //     action: message,
        //     data
        // });
    }

    async login(email, password) {
        const result = await axios.post(APIAUTH_URL + '/auth/login', {
            Email: email,
            Password: password,
            AppKey: AppKey
        });
        this.log('login', result.data);
        //        localStorage.setItem('authToken', result.data.accessToken);
        //       localStorage.setItem('refreshToken', result.data.refreshToken);
        //await useAuthStore.dispatch('setAuth', result.data); //vuex

        const authStore = useAuthStore();
        authStore.setSession(result.data);

        await loadShops();
        return result.data;
    }

    async logout() {
        var refToken = localStorage.getItem('refreshToken');

        if (refToken != null) {
            const result = await axios.post(APIAUTH_URL + '/auth/logout', {
                RefreshToken: localStorage.getItem('refreshToken')
            });
            this.log('logout', result.data);
        }

        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
    }

    async refresh() {
        console.log("1...")
        var refToken = localStorage.getItem('refreshToken');

        if (refToken == null) {
            throw new Error("refreshToken not exists!");
        }

        const result = await axios.post(APIAUTH_URL + '/auth/refresh', {
            RefreshToken: refToken
        });
        console.log("2...")
        this.log('refresh', result.data);

        const newAccessToken = result.data.accessToken;

        localStorage.setItem('authToken', newAccessToken);
        localStorage.setItem('refreshToken', result.data.refreshToken);

        return newAccessToken;
    }

    getAuthToken() {
        this.log('getAuthToken');
        return localStorage.getItem('authToken');
    }

    isLogged() {
        this.log('isLogged');
        return this.getAuthToken() != null;
    }

    async getProtectedData() {
        this.log('getProtectedData');
        return await axios.get(API_URL + 'protected/data', { headers: authHeader() });
    }
}

export const authService = new AuthService();
